import {OrganManagerType} from "../../../../types/organShare";
import {RadioGroupField} from "../../../../components/RadioGroupField";
import React from "react";
import {
    useOrganManagerAuthorityActions
} from "../../../member/organmanager/detail/info/hooks/useOrganManagerAuthorityActions";

interface Props {
    managerType: OrganManagerType;
    setManagerType: (_: OrganManagerType) => void;
}
export function OrganManagerAuthorityField({managerType, setManagerType}:Props) {

    const { toStringOrganManagerAuthorityTypes, organManagerTypes} = useOrganManagerAuthorityActions();

    return (
        <RadioGroupField enumValues={organManagerTypes}
                         getLabel={toStringOrganManagerAuthorityTypes}
                         value={managerType} setValue={setManagerType}
                         groupName={"organManagerAuthorityType"} isRequired={true}
        />
    );
}